import gameSet from '@/api/administrator/game-set'
import gameSetting from '@/api/administrator/game-setting'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return gameSet.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return gameSet.store(data)
  },
  update(context, { id, data }) {
    return gameSet.update(id, data)
  },
  destroy(context, { id, data }) {
    return gameSet.destroy(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await game.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getGameSetting(context) {
    return gameSetting.get({
      params: {
        include: 'game_lots',
        fields: {
          game_settings: 'game_setting,game_setting_id,game_type_id'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
